import React from 'react'
import { Link } from 'react-router-dom'
import CarPricingAdd from './CarPricingAdd'
import Constant from '../../../Constant'

class CarPricingAddTab extends React.Component {
  state = {
    language_data: [],
  }

  componentDidMount() {
    if (
      this.props.match.params.id !== undefined &&
      this.props.match.params.id !== null &&
      this.props.match.params.id !== 0 &&
      this.props.match.params.id !== ''
    ) {
      this.setState({ id: this.props.match.params.id })
    }

    this.getLanguageList()
  }

  getLanguageList = () => {
    var language_data = Constant.getLanguageList()
    this.setState({
      ...this.state,
      language_data: language_data,
      language_id: language_data[0].id,
      isLoading: false,
    })
  }

  handleLanguage = (language_id) => {
    this.setState({ language_id: language_id })
  }

  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>
                      Car Pricing
                      {this.props.match.params.id ? ' Edit' : ' Add'}
                    </h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="page-header-breadcrumb">
                  <ul className="breadcrumb-title">
                    <li className="breadcrumb-item">
                      <Link to="/">
                        <i className="feather icon-home"></i>{' '}
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to={`/car-pricing/${this.props?.match?.params?.companyId}/${this.props?.match?.params?.carId}`}> Car Pricing List</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Car Pricing {this.props.match.params.id ? 'Edit' : 'Add'}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-block">
                    <div className="tab-content tabs">
                      <div
                        className="tab-pane  active"
                        id={'Products_add_' + this.state.language_id}
                        role="tabpanel"
                        aria-labelledby=""
                      >
                        {this.state.id !== undefined &&
                          this.state.id !== null &&
                          this.state.id !== 0 &&
                          this.state.id !== '' ? (
                          <CarPricingAdd
                            language_id={this.state.language_id}
                            goBack={this.props.history.goBack}
                            id={this.state.id}
                            car_id={this.props?.match?.params?.carId}
                            company_id={this.props?.match?.params?.companyId}
                          />
                        ) : (
                          <CarPricingAdd
                            language_id={this.state.language_id}
                            goBack={this.props.history.goBack}
                            car_id={this.props?.match?.params?.carId}
                            company_id={this.props?.match?.params?.companyId}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CarPricingAddTab
